import React from 'react';
import './Features.css';

const Features = () => {
  const comparisonData = [
    { feature: 'Multi-branch data collection', preciseca: '✅ Automated', traditional: '❌ Manual' },
    { feature: 'Real-time sync with Tally', preciseca: '✅ Yes', traditional: '❌ No' },
    { feature: 'Consolidated reporting', preciseca: '✅ Instant', traditional: '❌ Time-consuming' },
    { feature: 'Role-based access control', preciseca: '✅ Built-in', traditional: '❌ Limited' },
    { feature: 'Cloud-based access', preciseca: '✅ Anywhere', traditional: '❌ Office only' },
    { feature: 'Data security', preciseca: '✅ Enterprise-grade', traditional: '⚠️ Variable' },
    { feature: 'Scalability', preciseca: '✅ Unlimited branches', traditional: '❌ Difficult' },
  ];

  const reportRows = [
    { feature: 'Multi Company Consolidation', light: 'Consolidated Reports for Current 1 FY at a time', ultimate: 'Consolidated + Comparative Reports for all FY' },
    { feature: 'Multi Company Comparison', light: 'No', ultimate: 'Compare multiple companies as well as self FY data' },
    { feature: 'Number of Reports', light: '7 Reports', ultimate: '30+ Reports' },
    { feature: 'Financial Report', light: 'Balance Sheet & Profit & Loss', ultimate: 'Balance Sheet & Profit & Loss with Standard Format as well as Schedule III Financial Reports' },
    { feature: 'Ledger Report', light: 'Trial Balance, Receivable, Payable', ultimate: 'Detailed Ledger View, Ageing Report wise Receivable & Payable' },
    { feature: 'Daybook', light: 'No', ultimate: 'Yes, Multi company consolidated Daybook – can check any company' },
    { feature: 'Inventory Report', light: 'Stock Summary', ultimate: 'Stock Summary, Movement Analysis Summary, Inventory Valuation' },
    { feature: 'GSTR1', light: 'Consolidated GSTR1 Multi Branch Same GSTN', ultimate: 'Consolidated GSTR1 Multi Branch Same GSTN' },
    { feature: 'HSN Summary', light: 'No', ultimate: 'HSN wise Summary' },
    { feature: 'GSTR2B Reconciliation', light: 'Multi Company vs GST Portal GSTR2B Reconciliation', ultimate: 'Multi Company vs GST Portal GSTR2B Reconciliation' },
  ];

  const pricingRows = [
    { feature: 'Per Company + Users', light: 'Per company Single FY = ₹4,000 /-', ultimate: 'Per company any FY with No limit = ₹10,000 /-' },
    { feature: 'Custom Reports', light: 'No', ultimate: 'Per report cost as per Scope of report' },
  ];

  const extraRows = [
    { feature: 'Company Extra', light: '₹4,000 /-', ultimate: '₹10,000 /-' },
    { feature: 'Users Extra', light: '₹2,500 /-', ultimate: '₹5,000 /-' },
  ];

  const packageRows = [
    { emoji: '🌱', name: 'Basic', feature: '3 Companies | 1 User', light: '₹12,000 /-', ultimate: '₹30,000 /-' },
    { emoji: '🚀', name: 'Starter', feature: '5 Companies | 3 Users', light: '₹20,000 /-', ultimate: '₹50,000 /-' },
    { emoji: '📈', name: 'Growth', feature: '10 Companies | 5 Users', light: '₹40,000 /-', ultimate: '₹1,00,000 /-' },
    { emoji: '💼', name: 'Professional', feature: '25 Companies | 10 Users', light: '₹1,00,000 /-', ultimate: '₹25,00,000 /-' },
  ];

  return (
    <section id="features" className="features">
      <div className="container">
        <h2 className="section-title">Smart Features with PreciseCA – Built to Solve Real Business Needs</h2>

        <h3 className="comparison-title">PreciseCA vs Traditional Solutions</h3>
        <div className="table-wrapper">
          <table className="comparison-table">
            <thead>
              <tr>
                <th>Feature</th>
                <th>PreciseCA</th>
                <th>Traditional Solutions</th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, i) => (
                <tr key={i}>
                  <td>{row.feature}</td>
                  <td>{row.preciseca}</td>
                  <td>{row.traditional}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Light vs Ultimate Version */}
        <div id="version-pricing" className="version-comparison">
          <h3 className="version-main-title">PreciseCA Light Version vs Ultimate Version</h3>
          <p className="version-subtitle">Choose the plan that fits your business needs</p>

          <div className="pricing-table-wrapper">
            <table className="pricing-table">
              <thead>
                <tr>
                  <th className="pt-feature-head">Report Format</th>
                  <th className="pt-light-head">PreciseCA Light Version</th>
                  <th className="pt-ultimate-head">PreciseCA Ultimate Version</th>
                </tr>
              </thead>
              <tbody>
                {reportRows.map((row, i) => (
                  <tr key={`r-${i}`}>
                    <td className="pt-feature">{row.feature}</td>
                    <td className="pt-light">{row.light}</td>
                    <td className="pt-ultimate">{row.ultimate}</td>
                  </tr>
                ))}

                {/* Section: Pricing */}
                <tr className="pt-section-row">
                  <td colSpan="3">Per Company & User Price – Yearly Renewal</td>
                </tr>
                {pricingRows.map((row, i) => (
                  <tr key={`p-${i}`}>
                    <td className="pt-feature">{row.feature}</td>
                    <td className="pt-light">{row.light}</td>
                    <td className="pt-ultimate">{row.ultimate}</td>
                  </tr>
                ))}

                {/* Section: Extra */}
                <tr className="pt-section-row">
                  <td colSpan="3">Add-on Pricing</td>
                </tr>
                {extraRows.map((row, i) => (
                  <tr key={`e-${i}`}>
                    <td className="pt-feature">{row.feature}</td>
                    <td className="pt-light pt-price">{row.light}</td>
                    <td className="pt-ultimate pt-price">{row.ultimate}</td>
                  </tr>
                ))}

                {/* Section: Packages */}
                <tr className="pt-section-row">
                  <td colSpan="3">Packages</td>
                </tr>
                {packageRows.map((row, i) => (
                  <tr key={`pkg-${i}`} className="pt-package-row">
                    <td className="pt-feature pt-package-name">
                      <span className="pkg-emoji">{row.emoji}</span>
                      <span>
                        <strong>{row.name}</strong>
                        <small>{row.feature}</small>
                      </span>
                    </td>
                    <td className="pt-light pt-price">{row.light}</td>
                    <td className="pt-ultimate pt-price">{row.ultimate}</td>
                  </tr>
                ))}

                {/* Enterprise */}
                <tr className="pt-enterprise-row">
                  <td className="pt-feature">Enterprise Package</td>
                  <td className="pt-light">Connect for Price</td>
                  <td className="pt-ultimate">Connect for Price</td>
                </tr>
              </tbody>
            </table>

            {/* CTA */}
            <div className="pt-cta-row">
              <div></div>
              <a href="#contact" className="btn-version btn-light-version">Get Started</a>
              <a href="#contact" className="btn-version btn-ultimate-version">Get Started</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
